import React from "react";
import { Box, Typography } from "@mui/material";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import SeverityOfFaultsChartView from "./SeverityOfFaultsChartView";
import { formatDateRange } from "../../../Helper/Analytics/AnalyticsHelper";
import { useBaseEntityInfo } from "../../../Hooks/usePagesContent";

const SeverityOfFaultsChart = ({ onDetailsClick, startDate, endDate, hierarchicalLocation, fleetIds, onboardingLocations, allOnboardingLocations, alertCategories, operationalStatus }) => {
  const {baseEntityType, baseEntityTypeIDLable, baseEntityTypeLable, baseEntityTypePluralLable} = useBaseEntityInfo();

  return (
    <Box
      sx={{
        backgroundColor: "#FFFFFF",
        borderRadius: "8px",
        padding: "24px 22px",
        border: "1px solid #E6E6E6",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Typography
            variant="fw600s16lh24c444B51"
            sx={{ color: "#2E2E2E" }}
          >
            Severity of Faults Triggered vs {baseEntityTypePluralLable} Impacted
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: "pointer",
              "&:hover": {
                "& .MuiTypography-root": {
                  color: '#4D44D8'
                },
                "& .MuiSvgIcon-root": {
                  color: "#4D44D8",
                },
              }
            }}
            onClick={onDetailsClick}
          >
            <Typography
              variant="fw500s12lh20c000000"
              sx={{ color: "#6D72F6" }}
            >
              Details
            </Typography>
            <ChevronRightIcon sx={{ color: '#6D72F6', fontSize: "18px" }} />
          </Box>
        </Box>
        <Typography variant="fw400s12c686868" sx={{ lineHeight: "20px" }}>
          {formatDateRange(startDate, endDate)}
        </Typography>
      </Box>

      {/* Chart */}
      <SeverityOfFaultsChartView
        startDate={startDate}
        endDate={endDate}
        isSidebarExpanded={false}
        filters={[]}
        hierarchicalLocation={hierarchicalLocation}
        fleetIds={fleetIds}
        onboardingLocations={onboardingLocations}
        allOnboardingLocations={allOnboardingLocations}
        alertCategories={alertCategories}
        operationalStatus={operationalStatus}
      />
    </Box>
  );
};

export default SeverityOfFaultsChart;
